<template>
  <ul class="main-menu">
    <li
      v-for="menuItem in menuNodes"
      :key="menuItem.title"
      class="main-menu__list-item"
      :class="menuItemClass(menuItem)"
      @mouseenter="hasChildMenu(menuItem) && !isTouchDevice && handleClick(menuItem)"
      @mouseleave="closeMenu">
      <template v-if="hasChildMenu(menuItem)">
        <button
          class="main-menu__item"
          @click.stop.prevent="handleClick(menuItem)">
          <span v-html="menuItem.title" />
          <icon-triangle class="main-menu__item-icon" />
        </button>
        <div class="main-menu__subtree">
          <child-menu class="main-menu__submenu" :menu-items="menuItem.children" @linkClicked="handleLinkClicked" />
        </div>
      </template>
      <nuxt-link
        v-else
        class="main-menu__item"
        :to="menuItem.uri"
        :target="menuItem.inNewTab ? '_blank' : '_self'"
        @click="closeMenu">
        <span v-html="menuItem.title" />
      </nuxt-link>
    </li>
  </ul>
</template>

<script lang="ts">
import ChildMenu from "~/components/parts/menu/ChildMenu.vue";
import IconTriangle from '~/assets/icons/IconTriangle.svg';
import { startListening, stopListening } from "~/common/ts/clickAway";

export default {
  props: {
    menuNodes: Array,
  },
  components: {
    ChildMenu,
    IconTriangle,
  },
  data () {
    return {
      openMenu: null,
      isTouchDevice: false,
    };
  },
  mounted() {
    this.checkTouchDevice();
    window.addEventListener('resize', this.checkTouchDevice);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkTouchDevice);
  },
  watch: {
    $route () {
      this.closeMenu();
    },
  },
  methods: {
    checkTouchDevice() {
      // Mobile menu mode below 1440px - disable hover behavior
      this.isTouchDevice = window.innerWidth < 1440;
    },
    hasChildMenu (menuItem) {
      return menuItem.children.length > 0;
    },
    menuItemClass (menuItem) {
      return {
        'main-menu__list-item--special': menuItem.uri.startsWith('/community'),
        'main-menu__list-item--open': this.openMenu === menuItem.id,
      };
    },
    handleClick (menuItem) {
      if (this.openMenu === menuItem.id) {
        this.closeMenu();
      } else {
        this.openMenu = menuItem.id;
        //startListening(this.$el, this.closeMenu);
      }
    },
    closeMenu () {
      this.openMenu = null;
      //stopListening(this.$el, this.closeMenu);
    },
    handleLinkClicked() {
      this.closeMenu();
      this.$emit('linkClicked');
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/container";
@use "~/common/scss/variables";
@use "~/common/scss/helpers";
@use "~/common/scss/mq";

.main-menu {
  $root: &;

  display: flex;
  list-style: none;
  gap: helpers.px-to-rem(30);

  @include mq.mq(variables.$mq-4-max) {
    flex-flow: column;
    gap: 0;
  }

  &__list-item {
    @include mq.mq(variables.$mq-4-max) {
      @include container.s();
    }
  }

  &__item {
    align-items: center;
    color: var(--color-black);
    display: flex;
    gap: .4rem;
    padding: helpers.px-to-rem(10) 0;
    text-decoration: none;
    transition: color .25s;
    white-space: nowrap;

    @include mq.mq(variables.$mq-4-max) {
      border-bottom: 1px solid variables.$colorGreyBorder;
      justify-content: space-between;
      padding: helpers.px-to-rem(10) helpers.px-to-rem(20);
      width: 100%;
    }

    @include mq.mq(variables.$mq-5-min) {
      height: 100%;
    }

    &:hover,
    #{$root}__list-item--open & {
      color: var(--color-orange);
    }

    #{$root}__list-item--special & {
      transition: none;

      &:not(:hover) {
        background: linear-gradient(90deg, variables.$colorYellow, variables.$colorOrange 55%, variables.$colorPurple);
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      &:hover {
        color: var(--color-orange);
      }
    }
  }

  &__item-icon {
    font-size: .5rem;
    transform: rotate(180deg);
    transition: transform .25s;

    #{$root}__list-item--open & {
      transform: rotate(0);
    }
  }

  &__subtree {
    background-color: #F4F4F4;
    display: flex;
    /*left: 0;*/
    overflow: visible;
    transition: opacity .25s;
    /*width: 100%;*/

    @include mq.mq(variables.$mq-4-max) {
      border-bottom: 1px solid variables.$colorGreyBorder;
      display: none;

      #{$root}__list-item--open & {
        display: flex;
      }
    }

    @include mq.mq(variables.$mq-5-min) {
      box-shadow: 0 .25rem .5rem #666;
      /*height: min(calc(100vh - 100%), #{helpers.px-to-rem(600)});*/
      opacity: 0;
      padding: 1rem;
      position: absolute;
      pointer-events: none;
      top: 100%;

      #{$root}__list-item--open & {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  &__submenu {
    width: 100%;
  }
}
</style>